<template>
  <section
    class="component-fcbecf18"
    resmed-component-name="feature_50/50_icon-line_text_2cta"
    v-bind:style="background"
  >
    <div
      class="component"
      v-bind:style="padding"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-6 col-lg-6 order-md-2 mb-5 mb-md-0">
            <div v-if="acf.animation" v-bind:style="transform">
              <animation
                v-bind:animation="JSON.parse(acf.animation)"
              ></animation>
            </div>
            <div v-if="acf.image" v-bind:style="transform">
              <figure>
                <img class="img-fluid" v-bind:src="acf.image" alt="" />
              </figure>
            </div>
          </div>

          <div
            class="col-md-6 order-md-1"
            v-bind:class="{
              'col-lg-5 offset-lg-1': acf.layout.offset,
              'col-lg-6': !acf.layout.offset,
            }"
          >
            <div>
              <h5 v-if="acf.steps.step" class="step">{{ acf.steps.step }}</h5>
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <h5 v-if="acf.name">{{ acf.name }}</h5>

              <h1
                v-if="acf.layout['heading-tag'] === 'h1'"
                v-html="acf.headline"
              ></h1>
              <h2
                v-if="acf.layout['heading-tag'] === 'h2'"
                v-html="acf.headline"
                v-bind:class="{ 'has-step': acf.steps.step }"
              ></h2>

              <div v-if="acf.content" v-html="acf.content"></div>

              <ul v-if="acf['list-items']" class="mt-4">
                <li v-for="(content, index) in acf['list-items']">
                  <div class="numbers">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <div v-html="content.item"></div>
                </li>
              </ul>

              <a
                v-if="acf.cta.href"
                v-bind:href="acf.cta.href"
                class="btn mt-4"
                v-bind:target="acf.cta.target"
                v-bind:class="{
                  'cta-plain text-red icon right-arrow':
                    acf.cta.style === 'text',
                  'cta-pill filled-red icon right-arrow':
                    acf.cta.style === 'pill' &&
                    acf.layout['text-color'] !== 'white',
                  'cta-pill hallow-white icon right-arrow':
                    acf.cta.style === 'pill' &&
                    acf.layout['text-color'] === 'white',
                }"
                >{{ acf.cta.text }}</a
              >

              <!-- 2nd cta - optional (included afterwards) -->
              <a
                v-if="acf.cta2.href"
                class="btn mt-4 ml-2 cta-pill hallow-red icon right-arrow"
                v-bind:href="acf.cta2.href"
                v-bind:target="acf.cta2.target"
                >{{ acf.cta2.text }}</a
              >

              <a
                v-if="acf.steps.step"
                v-bind:href="'#'"
                v-on:click.prevent="next(acf.steps.next)"
                class="btn cta-pill hallow-red icon right-arrow ml-2"
                >Next step</a
              >
            </div>
          </div>
        </div>
      </div>

      <steps-fcbecf18
        v-if="acf.steps.step"
        v-bind:acf="acf.steps"
      ></steps-fcbecf18>
    </div>
  </section>
</template>

<script>
import stepsFcbecf18 from "../shared-support/steps-fcbecf18";
import { scroll } from "../../mixins/index";

export default {
  name: "component-fcbecf18", // feature_50/50_icon-line_text_2cta
  props: ["acf"],
  components: {
    stepsFcbecf18,
  },
  mixins: [scroll],
  data() {
    return {
      transform: {
        transform: "",
      },
      padding: {
        "padding-top": "",
        "padding-bottom": "",
      },
      background: {
        "background-color": this.acf.layout["background-color"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        // transform
        if (val === "xs" || val === "sm") {
          this.transform["transform"] = this.acf.layout["transform"]["xs"];
        }
        if (val === "md") {
          this.transform["transform"] = this.acf.layout["transform"]["md"];
        }
        if (val === "lg" || val === "xl") {
          this.transform["transform"] = this.acf.layout["transform"]["lg"];
        }

        // padding
        if (val === "xs" || val === "sm") {
          this.padding["padding-top"] = !this.acf.layout["padding"]["xs"]["top"]
            ? ""
            : this.acf.layout["padding"]["xs"]["top"];
          this.padding["padding-bottom"] = !this.acf.layout["padding"]["xs"][
            "bottom"
          ]
            ? ""
            : this.acf.layout["padding"]["xs"]["bottom"];
        }
        if (val === "md") {
          this.padding["padding-top"] = this.acf.layout["padding"]["md"]["top"];
          this.padding["padding-bottom"] =
            this.acf.layout["padding"]["md"]["bottom"];
        }
        if (val === "lg") {
          this.padding["padding-top"] = this.acf.layout["padding"]["lg"]["top"];
          this.padding["padding-bottom"] =
            this.acf.layout["padding"]["lg"]["bottom"];
        }
        if (val === "xl") {
          this.padding["padding-top"] = this.acf.layout["padding"]["xl"]["top"];
          this.padding["padding-bottom"] =
            this.acf.layout["padding"]["xl"]["bottom"];
        }
      },
      immediate: true,
    },
  },
  methods: {
    next(arg) {
      this.$nextTick(() => {
        this.scroll({
          to: `[data-step='${arg}']`,
          offset: ["xs", "sm", "md"].includes(this.$root.mode) && 90,
        });
      });
    },
  },
  created() {
    if (this.acf.layout["background-gradient"]) {
      this.background["background-image"] =
        this.acf.layout["background-gradient"];
    }
    if (this.acf.layout["background-image"]) {
      this.background[
        "background-image"
      ] = `url(${this.acf.layout["background-image"]})`;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-fcbecf18 {
  background-repeat: no-repeat;
  background-size: cover;
}

.component {
  padding: 3rem 0;

  @media (min-width: 768px) {
    padding: 6rem 0 5rem 0;
  }

  &.text-color-white {
    h1,
    h2,
    h5 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h1 {
    margin: 0 0 0.325em 0;
  }

  h1,
  h2 {
    position: relative;
    margin-bottom: 1.25rem;

    @extend %eyebrow-left;

    &.has-step {
      &:before {
        display: none;
      }
    }
  }

  h5 {
    position: relative;
    margin: 0 0 0.5rem 0;

    @extend %body-normal-bold;
    @extend %eyebrow-left;

    + h1,
    + h2 {
      &:before {
        display: none;
      }
    }

    &.step {
      margin: 0 0 2.25rem 0;

      &:before {
        top: 2.25rem;
      }
    }
  }

  ul {
    list-style: none;

    li:not(:last-child) {
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
      border-bottom: 1px solid rgba($cc-resmed-grey-50, 0.25);
    }

    li {
      > :nth-child(1) {
        float: left;
        transform: translate3d(0, 0, 0);

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          width: 1.75rem;
          height: 1.75rem;
          border: 1px solid $cc-resmed-grey-50;
          border-radius: 50%;

          @extend %body-small;
        }
      }

      > :nth-child(2) {
        display: block;
        padding-left: 2.5rem;
      }
    }
  }
}
</style>